export function findInstallationBySlug(acceptedSubmissions, slug) {
  return acceptedSubmissions.installations.find((installation) => (installation.slug === slug));
}



// WEBPACK FOOTER //
// ./src/helpers/find-installation-by-slug.js